import { createTheme } from '@mui/material/styles';

const theme = createTheme({
	palette: {
		primary: {
			main: '#3576E5',
    },
    warning: {
			main: '#FF8F00',
		},
  },

  typography: {
        body2: {
          color: "#FFFF",
        },

        h4: {
            fontSize: 24,
        },
        button: {
          textTransform: 'none'
        }
  },

});

export default theme;